import { render, staticRenderFns } from "./AssignedEquipment.vue?vue&type=template&id=2b7e8cf1&scoped=true"
import script from "./AssignedEquipment.vue?vue&type=script&lang=js"
export * from "./AssignedEquipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7e8cf1",
  null
  
)

export default component.exports